module.exports = __webpack_public_path__ + "img/Apple_Podcast_Icon.cf0e79ff.png";